import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";

import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import classNames from "classnames";
import { Link } from "@reach/router";

import Drawer from "@material-ui/core/Drawer";

import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import TheatersIcon from "@material-ui/icons/Theaters";

class NestedList extends React.Component {
  render() {
    const { classes, isOpen, lessons = [], pathname } = this.props;
    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !isOpen && classes.drawerPaperClose
          )
        }}
        open={isOpen}
      >
        <div className={classes.toolbarIcon} />
        <Divider />
        <List
          subheader={
            <ListSubheader
              component="div"
              inset
              className={classes.listSubHeader}
            >
              <Typography variant="subheading" gutter="true">
                <b>Menu</b>
              </Typography>
            </ListSubheader>
          }
          disablePadding
        >
          <Divider />
          {lessons.map((lesson, index) => (
            <ListItem
              key={`${index}-${lesson.key}`}
              lesson={lesson}
              classes={classes}
              pathname={pathname}
            />
          ))}
        </List>
      </Drawer>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default NestedList;

const ListItem = ({ lesson, classes, pathname }) => {
  const [isOpen, toggle] = useState(false);
  return (
    <Fragment>
      <Tooltip
        title={lesson.tooltip}
        placement="right"
        classes={{
          popper: classes.htmlPopper,
          tooltip: classes.htmlTooltip
        }}
        TransitionComponent={Zoom}
      >
        <MenuItem
          button
          onClick={() => toggle(!isOpen)}
          classes={{
            selected: classes.selected
          }}
        >
          <ListItemIcon>
            <TheatersIcon />
          </ListItemIcon>
          <ListItemText inset={false}>
            <Typography variant="subheading">{lesson.name}</Typography>
          </ListItemText>
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>
      </Tooltip>
      <Collapse in={isOpen} unmountOnExit>
        <List component="div" disablePadding>
          {lesson.videos.map((video) => {
            return (
              <Fragment key={video.key}>
                <MenuItem
                  selected={`/main/video/${video.key}` === pathname}
                  component={Link}
                  to={`video/${video.key}`}
                  state={{ video }}
                  divider={true}
                  button
                  classes={{
                    selected: classes.selected
                  }}
                >
                  <ListItemText inset>
                    <Typography variant="subheading">
                      {`${video.name}`}
                    </Typography>
                  </ListItemText>
                </MenuItem>
              </Fragment>
            );
          })}
        </List>
      </Collapse>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/SideBar.js